import { clearContextualAuthIntentV2 } from '@/components/layout/contextualPanelAuthIntent.js';
import { clearPublicAuthDestination } from '@/lib/publicAuthDestination.js';

export async function signOutAndClearPublicAuthIntent({ signOut, storage } = {}) {
  if (typeof signOut !== 'function') {
    throw new TypeError('A signOut function is required.');
  }

  await signOut();
  const contextualIntentCleared = clearContextualAuthIntentV2(
    storage === undefined ? {} : { storage },
  );
  const directDestinationCleared = clearPublicAuthDestination(
    storage === undefined ? {} : { storage },
  );
  return contextualIntentCleared && directDestinationCleared;
}
